import { Menu, usePermissions } from "react-admin";
import ExtensionIcon from "@mui/icons-material/Extension";
import { NetworkPermissions } from "./NetworkModules";

export default function NetworkMenu() {
  const { permissions } = usePermissions<NetworkPermissions>();
  const system = permissions?.role === "SYSTEM_ADMIN";
  return (
    <Menu>
      <Menu.DashboardItem />
      <Menu.ResourceItems />
      {(system || !!permissions?.modules?.length) && (
        <Menu.Item
          to="/network-modules"
          primaryText={system ? "Modultildeling" : "Ekstra moduler"}
          leftIcon={<ExtensionIcon />}
        />
      )}
      {permissions?.modules
        ?.filter((module) => module.enabled && module.adminPath)
        .map((module) => (
          <Menu.Item
            key={module.key}
            to={module.adminPath!}
            primaryText={module.name}
            leftIcon={<ExtensionIcon />}
          />
        ))}
    </Menu>
  );
}
